import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';
import type { IRoute } from '..';

const DriversPage = lazy(() => import('@cobliteam/drivers/src/pages/DriverPage'));

const routes: IRoute[] = [
  {
    path: Location.DRIVER_MANAGEMENT,
    component: DriversPage,
    exact: true,
  },
  {
    path: Location.DRIVER_MANAGEMENT_NOT_IDENTIFIED,
    component: DriversPage,
    exact: true,
  },
  {
    path: Location.DRIVER_MANAGEMENT_IDENTIFIERS,
    component: DriversPage,
    exact: true,
  },
];

export default routes;
